import {gql} from 'apollo-angular';
import {StatusFragment} from "../fragments/Status";

export const GET_GAME = gql`
  query GetGame($gameType: GameType, $clientId: String!, $categoryIds: [Int!]!) {
    getGame(gameType: $gameType, clientID: $clientId, categoryIDs: $categoryIds) {
      status {
        ...statusFields
      }
      id,
      gameType,
      clientID,
      createdAt
    }
  }
  ${StatusFragment}
`;
